import { t } from "@/i18n-js/instance";
import { isValidURL } from "@/react/helpers/urlHelpers/isValidUrl";
import { Form } from "@circle-react-uikit/Form";

interface CustomRedirectInputTextProps {
  isDisabled?: boolean;
}

const ERROR_MESSAGES = {
  invalid: t(
    "settings.paywalls.modal.tabs.post_purchase.alerts.redirect_url_is_invalid",
  ),
};

export const CustomRedirectInputText = ({
  isDisabled,
}: CustomRedirectInputTextProps) => {
  if (isDisabled) {
    return null;
  }

  return (
    <Form.Item
      className="!mt-0 !py-0"
      name="redirect_url"
      translationRoot="settings.paywalls.modal.tabs.post_purchase"
      fullWidth
      hideBorder
      hideLabel
      hideDescription
      placeholder={window.location.origin}
      tooltipText={t(
        "settings.paywalls.modal.tabs.post_purchase.redirect_url_tooltip",
      )}
      rules={{
        validate: (input: string) =>
          input === "" || isValidURL(input) || ERROR_MESSAGES.invalid,
        maxLength: 255,
      }}
    >
      <Form.Input disabled={isDisabled} />
    </Form.Item>
  );
};
